<template>
	<b-modal
		header-class="header-class-modal-doc-package"
		ref="modal"
		v-model="isOpen"
		size="lg"
		:title="modalTitle"
		ok-variant="success"
		:ok-title="okTitle"
		@ok="onSubmit"
		@hidden="onCancel"
		ok-only
	>
		<b-container fluid>
			<b-row>
				<b-col cols="12">
					<green-film-docs :GFId="taskId" GFType="task" GFSubType="documents" :attachment-to-offer-order-invoice-only="isOffer" />
				</b-col>
			</b-row>
		</b-container>
	</b-modal>
</template>
<script>
import languageMessages from '@/mixins/languageMessages';
import Loading from 'vue-loading-overlay';
import GreenFilmDocs from '@/components/greenfilm/greenfilmdocs';

export default {
	name: 'TaskDocumentModal',
	mixins: [languageMessages],
	components: {
		Loading,
		GreenFilmDocs
	},
	props: {
		value: {
			type: Boolean,
			required: true,
			default: false
		},
		taskId: {
			type: [String, Number],
			required: true,
			default: '0'
		},
		isOffer: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	computed: {
		isOpen: {
			get() {
				return this.value;
			},
			set(val) {
				return val;
			}
		},
		modalTitle() {
			return this.FormMSG(1, 'Add documents') + `: #${this.taskId}`;
		},
		okTitle() {
			return this.FormMSG(2, 'Ok');
		}
	},
	methods: {
		onSubmit() {
			this.$emit('task-document:hidden', this.taskId);
		},
		onCancel() {
			this.$emit('task-document:hidden', this.taskId);
		}
	}
};
</script>
